import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue'

const testRoutes: RouteConfig = {
    path: '/download',
    component: Layout,
    meta: {
        title: 'download',
        icon: 'guide',
        redirect: '/download/download',
        // alwaysShow: true 
    },
    children: [
        {
            path: 'download',
            component: () => import('@/views/download/download.vue'),
            meta: {
                title: 'download',
                icon: 'guide',
                activeMenu: '/download/download',
            }
        }
    ]

}

export default testRoutes